import { required, numeric, maxLength } from '@vuelidate/validators'
import { isMyEasybellCom } from '@/utils/environment'
import { firstDigitInRange } from '@/validations/validators'
import { useCtaStore } from '@/stores/cta/store'
import { useExtensionsStore } from '@/stores/extensions/store'

export function getHasBlockNumbers() {
  // const trunks = store.getters['cta/getAvailableTrunks']
  const trunks = useCtaStore().getAvailableTrunks

  return trunks.some((trunk) => trunk.isBlockNumber)
}

export function getHasFreeSingleNumbers() {
  // const trunks = store.getters['cta/getAvailableTrunks']
  const trunks = useCtaStore().getAvailableTrunks

  // const extensions = store.getters['extensions/list']
  const extensions = useExtensionsStore().list

  return trunks.some((trunk) => {
    if (trunk.isBlockNumber) {
      return false
    }

    const hasExtensionAssigned = extensions.some(
      (extension) => extension.trunkId === trunk.id
    )

    return !hasExtensionAssigned
  })
}

export function getIsNumberModeBlock() {
  const element = document.querySelector<HTMLSelectElement>(
    '[data-test=numberMode]'
  )

  const value = element?.value

  const isBlockMode = value === 'false'

  return isBlockMode
}

/**
 * @param value - Direct dial value
 * @param trunkId - Id of the trunk for which the extension will be created
 */
export function getIsValidDirectDial(value: string, trunkId: string) {
  if (
    !required.$validator(value, undefined, undefined) ||
    !numeric.$validator(value, undefined, undefined) ||
    !maxLength(6).$validator(value, undefined, undefined)
  ) {
    return false
  }

  // Check if direct dial already used

  // const extensions = store.getters['extensions/list']
  const extensions = useExtensionsStore().list

  const directDialsOfSelectedTrunk = extensions
    .filter((extension) => String(extension.trunkId) === String(trunkId))
    .map((extension) => extension.directDial)

  const isDirectDialAlreadyUsed = directDialsOfSelectedTrunk.includes(value)

  if (isDirectDialAlreadyUsed) {
    return false
  }

  // Check if first digit is in trunk range

  // const trunks = store.getters['cta/getAvailableTrunks']
  const trunks = useCtaStore().getAvailableTrunks

  const trunk = trunks.find((trunk) => String(trunk.id) === trunkId)

  const isFirstDigitInRange = firstDigitInRange(
    trunk?.blockRangeStart,
    trunk?.blockRangeEnd
  ).$validator(value, undefined, undefined)

  if (!isFirstDigitInRange) {
    return false
  }

  return true
}

/**
 * @param value - Quick dial value
 */
export function getIsValidQuickDial(value: string) {
  if (
    !required.$validator(value, undefined, undefined) ||
    !numeric.$validator(value, undefined, undefined) ||
    !maxLength(6).$validator(value, undefined, undefined)
  ) {
    return false
  }

  // Check if quick dial is used

  // const extensions = store.getters['extensions/list']
  const extensions = useExtensionsStore().list

  const allQuickDials = extensions.map((extension) => extension.quickDial)

  const isQuickDialAlreadyUsed = allQuickDials.includes(value)

  if (isQuickDialAlreadyUsed) {
    return false
  }

  // Check pattern is not all zeroes

  const isAllZeros = /^0+$/.test(value)

  if (isAllZeros) {
    return false
  }

  // Check pattern is not emergency services

  const isDutchEmergencyService =
    /^112|08008112|09008844|0343578844|09001844|08000113|144|09001231230|08009050$/.test(
      value
    )

  const isAustrianEmergencyService =
    /^112|122|128|133|140|141|142|144|147|911$/.test(value)

  const isFrenchEmergencySerice = /^112|114|115|196|197|15|17|18|119$/.test(
    value
  )

  const isGermanEmergencyService = /^(11[0-9]|911)$/.test(value)

  const isEmergencyServiceNumber = isMyEasybellCom()
    ? isAustrianEmergencyService ||
      isFrenchEmergencySerice ||
      isDutchEmergencyService
    : isGermanEmergencyService

  if (isEmergencyServiceNumber) {
    return false
  }

  return true
}
